import React, {useEffect, useState} from 'react';
import EmptyBox from "components/emptyBox/EmptyBox";
import BasketItem from "./BasketItem";
import BasketInfo from "./BasketInfo";
import {IsLP_MP_SP_T} from "my-styles/media/media";
import BasketChangeSet from "./BasketChangeSet";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import messages from "res/messages/farsi";

export default function Basket(props) {

    const [isCancelled, setIsCancelled] = useState(false)
    const [cart, setCart] = useState({})
    const [showEmptyBox, setShowEmptyBox] = useState(false)
    const [basketChangeset, setBasketChangeset] = useState([])

    function requestGetCart() {
        basketViewModel.getCart((data) => {
            if (isCancelled) return

            setCart(data)
            if (data.products.length > 0) {
                setShowEmptyBox(false)
            } else {
                setShowEmptyBox(true)
            }
            if (data.cart_change_set && data.cart_change_set.length > 0) {
                setBasketChangeset(data.cart_change_set)
            } else {
                setBasketChangeset([])
            }
        }, () => {
            setCart({})
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {

        }, () => {

        })
    }

    useEffect(() => {

        requestGetCart()
        basketViewModel.cartChange.subscribe((status) => {
            if (isCancelled) return

            if (status === true) {
                requestGetCart()
            }
        })

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div className="marginSmall paddingTopInTPMS">
        {showEmptyBox ?
            <div style={{paddingTop: "2em"}}>
                <EmptyBox message={messages.basketIsEmpty}/>
            </div> :
            <div className="hInLPT_vInFMS">
                {cart.products &&
                <div className={IsLP_MP_SP_T() ?
                    "wInLP65_wInT62_wInFMS100 marginRightMedium" :
                    "wInLP65_wInT62_wInFMS100 marginRightSmall"}>
                    {cart.products.map((product, index) => {
                        return <BasketItem key={index} {...props} product={product}/>
                    })}
                </div>
                }
                {cart.products &&
                <div className={IsLP_MP_SP_T() ?
                    "wInLPT32_wInFMS100 marginTopBottomSmall marginRightMedium" :
                    "wInLPT32_wInFMS100 marginTopBottomSmall"}>
                    <BasketInfo {...props} cart={cart}/>
                </div>
                }
            </div>
        }
        <BasketChangeSet
            showStatus={basketChangeset && basketChangeset.length > 0}
            changeSet={basketChangeset}
            onSubmitClicked={() =>
                setBasketChangeset([])
            }/>
    </div>)

}